export const SMALL_EDGE_SIZE = 35;
export const MEDIUM_EDGE_SIZE = 50;
export const DEFAULT_EDGE_SIZE = 150;
